import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const GhiChu = ({ nhanvayId }) => {
  const dataInit = {
    List: [],
  };
  const [dataGhiChu, UpdateDataGhiChu] = useState(dataInit);
  const DanhSachGhiChu = (page) => {
    NhanVayApi.getGhiChuNhanVay(nhanvayId).then((response) => {
      UpdateDataGhiChu({
        ...dataGhiChu,
        List: response.data.List,
      });
    });
  };

  React.useEffect(() => {
    DanhSachGhiChu(1);
  }, []);
  //End fix height tab

  const listItem = () => {
    return (
      dataGhiChu.List != null &&
      dataGhiChu.List.map((item, index) => {
        return (
          <>
            <tr>
              <td scope="row">{index + 1}</td>
              <td className="text-left">{item.NoiDung}</td>
              <td className="text-left"> {item.NguoiTao}</td>
              <td>{item.NgayTao}</td>
            </tr>
          </>
        );
      })
    );
  };
  return (
    <>
      <div className="table-from-detailtl5">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="w-stt">STT</th>
                  <th className="text-left">Nội dung</th>
                  <th className="w-15 text-left">Người tạo ghi chú</th>
                  <th className="w-10">Thời gian tạo</th>
                </tr>
              </thead>
              <tbody>{listItem()}</tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
